<template>
    <router-link v-if="linkType === 'routerLink'" :to="url" :class="className">
        <slot />
    </router-link>
    <a v-else :href="url" :class="className">
        <slot />
    </a>
</template>

<script>
export default {
    name: 'Link',
    data: () => ({
    }),
    props: {
        linkType: {
            type: String,
            default: 'routerLink'
        },
        url: {
            type: String,
            default: null
        },
        className: {
            type: String,
            default: null   
        }
    },
    components: {
    },
    computed: {
    },
    mounted() {
    },
    created() {
    },
    methods: {
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>
